@if (riskProfile()) {
  <div class="mcs-container" [class.mcs-container--panel]="variant() === 'panel'">
    <article class="mcs-card">
      <!-- Report (edit-assessment tab) keeps the header strip with the review
           pill + reference. In the detail drawer that lives in the panel's own
           header, so the eyebrow moves inside the identity card instead. -->
      @if (variant() === 'report') {
        <header class="mcs-report-header">
          <div class="mcs-report-eyebrow">
            <app-type-icon icon="ai-risk-assessment" variant="violet" size="small" />
            <span class="mcs-eyebrow-text">{{
              'model_card_summary.overview_eyebrow' | transloco
            }}</span>
          </div>
          <div class="mcs-report-header-end">
            @if (reviewStatus() === AssessmentReviewStatus.REVIEWED) {
              <app-status-indicator
                appearance="pill"
                status="active"
                icon="check_circle"
                [label]="getReviewStatusLabel(AssessmentReviewStatus.REVIEWED)"
              />
            } @else {
              <app-ai-label variant="full" state="generated" />
            }
            @if (reportReference(); as ref) {
              <span class="mcs-report-ref">{{ ref }}</span>
            }
          </div>
        </header>
      }

      <!-- ── Overview layout (Model Card) ── The identity block (eyebrow +
           title + summary + data-residency meta) reads as one card; "What it
           does" sits below it. In the drawer the identity card carries a
           visible border and the meta stacks; on the wide edit tab it's a
           plain grouping and the meta runs in a row. -->
      <div class="mcs-body mcs-body--overview">
        <div class="mcs-identity-card">
          @if (variant() === 'panel') {
            <div class="mcs-report-eyebrow">
              <app-type-icon icon="ai-risk-assessment" variant="violet" size="small" />
              <span class="mcs-eyebrow-text">{{
                'model_card_summary.overview_eyebrow' | transloco
              }}</span>
            </div>
          }

          <div class="mcs-title-block">
            <h1 class="mcs-title">{{ assessmentName() }}</h1>
            @if (summaryText(); as summary) {
              <p class="mcs-subtitle">{{ summary }}</p>
            }
          </div>

          @if (hasOverviewMeta()) {
            <div class="mcs-overview-meta">
              @if (generatedContent()?.deployment; as deployment) {
                <div class="mcs-overview-cell">
                  <span class="mcs-meta-label">{{
                    'model_card_summary.deployment_label' | transloco
                  }}</span>
                  <span class="mcs-meta-value">{{ deployment }}</span>
                </div>
              }
              @if (generatedContent()?.ai_components; as aiComponents) {
                <div class="mcs-overview-cell">
                  <span class="mcs-meta-label">{{
                    'model_card_summary.ai_components_label' | transloco
                  }}</span>
                  <span class="mcs-meta-value">{{ aiComponents }}</span>
                </div>
              }
              @if (assessedDate(); as assessed) {
                <div class="mcs-overview-cell mcs-overview-cell--end">
                  <span class="mcs-meta-label">{{
                    'model_card_summary.assessed_label' | transloco
                  }}</span>
                  <span class="mcs-meta-value">{{ assessed }}</span>
                </div>
              }
            </div>
          }
        </div>

        @if (whatItDoesParagraphs().length > 0) {
          <section class="mcs-what-it-does">
            <header class="mcs-section-eyebrow">
              <mat-icon aria-hidden="true">info</mat-icon>
              <span>{{ 'model_card_summary.what_it_does' | transloco }}</span>
            </header>
            @for (paragraph of whatItDoesParagraphs(); track $index) {
              <p class="mcs-what-it-does-text">{{ paragraph }}</p>
            }
          </section>
        }
      </div>

      <!-- Export footer — only in the detail-panel; the edit-assessment tab
           exports from its own header toolbar. -->
      @if (variant() === 'panel') {
        <footer class="mcs-footer">
          <p class="mcs-footer-hint">{{ 'model_card_summary.export_hint' | transloco }}</p>
          <button
            type="button"
            class="mcs-export-btn"
            (click)="onExportClick()"
            [disabled]="!canExport() || isExporting()"
            [title]="
              canExport() ? ('model_card_summary.export_title' | transloco) : exportTooltip()
            "
            [attr.aria-label]="'model_card_summary.export_aria' | transloco"
          >
            @if (isExporting()) {
              <mat-icon class="spinner-icon">hourglass_empty</mat-icon>
            } @else {
              <mat-icon>download</mat-icon>
            }
            <span>{{ 'model_card_summary.export_cta' | transloco }}</span>
          </button>
        </footer>
      }
    </article>
  </div>
} @else {
  <div class="mcs-container" [class.mcs-container--panel]="variant() === 'panel'">
    <article class="mcs-card mcs-card--empty">
      <div class="mcs-body">
        <app-empty-state
          variant="panel"
          icon="assessment"
          [title]="'model_card.empty_title' | transloco"
          [message]="'model_card.empty_message' | transloco"
        />
      </div>
    </article>
  </div>
}
